import * as React from "react";
import TextField from "@mui/material/TextField";

const CustomTextField = ({
  handleInputChange,
  inputValue,
  defaultValue,
  name,
  placeholder,
  className,
}) => {
  const inputRef = React.useRef(null);

  const handleInputChangeWithResize = (event) => {
    handleInputChange(event);

    if (inputRef.current) {
      // always reset to default 20px
      inputRef.current.style.height = "20px";

      // only expand if content overflows
      if (inputRef.current.scrollHeight > 25) {
        inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
      }
    }
  };

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = "20px";
      if (inputRef.current.scrollHeight > 25) {
        inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
      }
    }
  }, []);

  return (
    <TextField
      id="custom-textfield"
      variant="standard"
      multiline
      minRows={1}
      maxRows={10}
      defaultValue={defaultValue}
      placeholder={placeholder}
      name={name}
      value={inputValue}
      onChange={handleInputChangeWithResize}
      inputRef={inputRef}
      InputProps={{
        disableUnderline: true,
      }}
      // style={{ height: "20px", width: "100%", minWidth: 200, marginBottom:"0px" ,
        
      // }}
      style={{ minWidth: 119, marginBottom: 0 }}
      sx={{
        // height: "20px",
        "& .MuiInputBase-root": {
          // height: "20px",
          // minHeight: "20px",
          padding: "0 !important",
          margin: 0,
          alignItems: "center",
           marginBottom:"0px" 
        },
        "& textarea": {
          // height: "20px",
          // minHeight: "20px",
          maxHeight: "none",
          lineHeight: "20px",
          padding: "0 !important",
          margin: 0,
          overflow: "hidden",
          resize: "none",
          // color: "#000000",
          fontSize: "20px",
           marginBottom:"0px" ,
                         color: "black !important",

        },
      }}
    />
  );
};

export default CustomTextField;
